import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { BankStatementRuleConditionKindEnum } from '@zaoblako/shared/modules/document/enums/bank.statement.rule.condition.kind.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link BankStatementRuleConditionKindEnum} enumeration values */
export const BankStatementRuleConditionKindEnumI18n: EnumI18nInterface<BankStatementRuleConditionKindEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [BankStatementRuleConditionKindEnum.COMPANY]: 'Компания',
    [BankStatementRuleConditionKindEnum.COMPANY_BANK_DETAILS]: 'Банковские реквизиты компании',
    [BankStatementRuleConditionKindEnum.CONTRAGENT]: 'Контрагент',
    [BankStatementRuleConditionKindEnum.DATE]: 'Конкретная дата',
    [BankStatementRuleConditionKindEnum.AMOUNT]: 'Сумма',
  },
  [I18nLocalesEnum.EN_US]: {
    [BankStatementRuleConditionKindEnum.COMPANY]: 'Company',
    [BankStatementRuleConditionKindEnum.COMPANY_BANK_DETAILS]: 'Company bank details',
    [BankStatementRuleConditionKindEnum.CONTRAGENT]: 'Counterparty',
    [BankStatementRuleConditionKindEnum.DATE]: 'Concrete date',
    [BankStatementRuleConditionKindEnum.AMOUNT]: 'Amount',
  },
};
